import { CanActivateFn, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@abp/ng.core';

/**
 * Custom auth guard that redirects unauthenticated users to Angular's /login page
 * instead of ABP's backend /Account/Login page.
 *
 * This guard stores the attempted URL as returnUrl so the user can be redirected
 * back after successful login.
 */
export const customAuthGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  const returnUrl = state.url;

  // Navigate to Angular's custom login page with returnUrl
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl }
  });
};
